module.exports = __webpack_public_path__ + "static/media/ttn_mobile.c4ebb268.png";